// extracted by mini-css-extract-plugin
export default {"price":"R7-z","priceRow":"S7-z","onSale":"T7-z","msrpLabelPrice":"U7-z","msrpLabel":"V7-z","originalPrice":"W7-z","percentOff":"X7-z"};